import { defaultApi } from '@mint-sdk/api-core';
import type { z } from 'zod';

import {
  GetMediaDataQuerySchema,
  GetMediaDataResponseSchema,
  type MediaDataSchema,
} from '../shared/schemas/mediaData.js';

export type MediaData = z.infer<typeof MediaDataSchema>;
export type GetMediaDataResponse = z.infer<typeof GetMediaDataResponseSchema>;
export { LevelTypeEnum, MediaDataSchema } from '../shared/schemas/mediaData.js';

export const getMediaData = defaultApi.declareEndpoint({
  url: 'planning-service/media-lines/$mediaDataId/' as const,
  method: 'GET',
  querySchema: GetMediaDataQuerySchema,
  responseSchema: GetMediaDataResponseSchema,
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
});
